"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Board_1 = __importDefault(require("@containers/common/Board"));
const PageButton_1 = __importDefault(require("@containers/common/PageButton"));
const PageButtonGroup_1 = __importDefault(require("@containers/common/PageButtonGroup"));
const uiFlowUtils_1 = require("@containers/common/utils/uiFlowUtils");
const pageService_1 = require("../service/pageService");
const PageButtonGroup = (props) => {
    const { setPageRoutes, pageRoutes } = props;
    const changePageRoute = (route) => {
        setPageRoutes(Object.assign(Object.assign({}, pageService_1.initPageRoutes), { [route]: {
                isExpand: true,
                isDisplay: true
            }, pageButtonGroup: Object.assign(Object.assign({}, pageRoutes.pageButtonGroup), { isExpand: false }) }));
    };
    const scrollToTargetForm = (route) => {
        const element = document.getElementById(route);
        if (element)
            element.scrollIntoView({ behavior: 'smooth' });
    };
    const handleClickCard = (event, route) => {
        event.preventDefault();
        changePageRoute(route);
        scrollToTargetForm(route);
    };
    return ((0, jsx_runtime_1.jsx)(Board_1.default, Object.assign({ title: "\u793A\u4F8B\u8868\u683C", handleToggleExpand: () => (0, uiFlowUtils_1.handleClickExpand)(setPageRoutes, pageRoutes, 'pageButtonGroup'), isContentShow: pageRoutes.pageButtonGroup.isExpand, boardStyle: "grey" }, { children: (0, jsx_runtime_1.jsxs)(PageButtonGroup_1.default, { children: [(0, jsx_runtime_1.jsx)(PageButton_1.default, { className: pageRoutes.searchForm.isDisplay ? 'active' : '', onClick: (event) => handleClickCard(event, 'searchForm'), pageName: "\u67E5\u8A62\u7528\u6236" }), (0, jsx_runtime_1.jsx)(PageButton_1.default, { className: pageRoutes.addForm.isDisplay ? 'active' : '', onClick: (event) => handleClickCard(event, 'addForm'), pageName: "\u65B0\u589E\u7528\u6236" })] }) })));
};
exports.default = PageButtonGroup;
